// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card[data-v-b553753e] {
  padding: 8px;
}`, "",{"version":3,"sources":["webpack://./src/Web/scripts/components/publication/PublicationLoginSettingsCard.vue","webpack://./PublicationLoginSettingsCard.vue"],"names":[],"mappings":"AAEA;EACE,YAAA;ACDF","sourcesContent":["@import \"@/styles/breakpoint-mixin.scss\";\n\n.card {\n  padding: 8px;\n}\n",".card {\n  padding: 8px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
